import {
  location as locationRes,
  searchTop as searchTopRes,
  searchTag as searchTagRes,
  searchInsUsers as searchInsUsersRes,
  searchProduct as searchProductRes,
  userMedias as mediaList,
  userStories as userStoriesRes,
  tagMedias as tagMediasRes,
  userDetail as userDetailRes,
  locationMedias,
  mediaSave as medaSaveRes,
  delMediaSaved as delMediaSavedRes,
  explore as exploreRes,
} from "../api/instagram";
import { initValidate } from "../utils/errors";
import {
  CURRENT_PUBLISHER_SIMPLE,
  SAVED_LIBRARY_LIST,
  SAVED_LIBRARY_PARAMS,
} from "../store/mutation-types";
import store from "../store/index";
import { Post } from "./model/post";

/**
 * 保存到saved
 * @param mediaId
 * @returns {Promise<void>}
 */
export async function mediaSave({ mediaId, model }) {
  await medaSaveRes({ media_id: mediaId });
  // 添加到saved列表中
  const savedList = store.getters[SAVED_LIBRARY_LIST];
  const params = store.getters[SAVED_LIBRARY_PARAMS];
  savedList.list = [model, ...savedList.list];
  savedList.count += 1;
  params.offset += 1;
  store.commit(SAVED_LIBRARY_LIST, savedList);
  store.commit(SAVED_LIBRARY_PARAMS, params);
}

/**
 * 从saved删除
 * @param mediaId
 * @returns {Promise<void>}
 */
export async function delMediaSaved({ mediaId, model }) {
  await delMediaSavedRes({ media_ids: [mediaId] });
  // 从saved列表中删除
  const savedList = store.getters[SAVED_LIBRARY_LIST];
  const params = store.getters[SAVED_LIBRARY_PARAMS];
  savedList.list = savedList.list.filter((s) => s.mediaId !== model.mediaId);
  savedList.count -= 1;
  params.offset -= 1;
  store.commit(SAVED_LIBRARY_LIST, savedList);
  store.commit(SAVED_LIBRARY_PARAMS, params);
}

/**
 * 搜索座标附近的地理位置信息。
 * @param q 地名关键词
 * @returns {*}
 */
export async function location({ q = "" }) {
  // let { lat, lng } = await getPosition()
  const currentPublisher = store.getters[CURRENT_PUBLISHER_SIMPLE];
  const { data } = await locationRes({
    q,
    accessToken: currentPublisher.userToken,
  });
  let locationList = [];
  locationList = data.data
    .filter(
      (item) =>
        item.location &&
        item.location.latitude !== undefined &&
        item.location.longitude !== undefined
    )
    .map((item) => {
      let address = "";
      let lat = 0;
      let lng = 0;
      if (item.location) {
        if (item.location.street) {
          address = `${item.location.street}`;
        }
        if (item.location.city) {
          if (address) {
            address = `${address},`;
          }
          address = `${address}${item.location.city}`;
        }
        if (item.location.country) {
          if (address) {
            address = `${address},`;
          }
          address = `${address}${item.location.country}`;
        }
        lat = item.location.latitude;
        lng = item.location.longitude;
      }
      return {
        name: item.name, // string | required
        address: address, // string | required
        lat: lat, // number | required
        lng: lng, // number | required
        external_id: item.id, // string | required
        external_id_source: "facebook_places", // string | required
      };
    });
  return locationList;
}

/**
 * 查询附近信息
 */
export async function searchNearLocation() {
  let { lat, lng } = await getPosition();
  // 判断是否之前已经保存了附近信息
  const { data } = await locationRes({ lat, lng, q: "" });
  return data.map((d) => formatSearch({ data: d, type: "InstagramLocation" }));
}

/**
 * 獲取instagram 用户信息
 * @param q 查询条件
 * @returns {*}
 */
export async function searchInsUsers({ q }) {
  const { data } = await searchInsUsersRes({ q });
  const list = data.map((item) => {
    return {
      user_id: item.id, // 用户id
      username: item.username, // username
      full_name: item.full_name,
      isVerified: item.is_verified, // 是否已认证
      image: item.profile_pic_url, // 头像图片
      profile_pic_url: item.profile_pic_url, // 和上面头像相同 只不过为了方便某些地方读的是profile_pic_url
    };
  });
  return {
    list, // 数据列表
    nextId: null, // 为了兼容product分页，此处强制鞋null 表示数据到底
  };
}

/**
 * 查询tag_product
 * @param q 关键词。
 * @param nextId 请求下一组数据
 * @returns {Promise<void>}
 */
export async function searchProduct({ q, nextId }) {
  const { data } = await searchProductRes({ q, next_id: nextId });
  return {
    list: data.products,
    nextId: data.next_id,
  };
}

/**
 * 查询 explore
 * @param nextId 请求下一组数据
 * @returns {Promise<void>}
 */
export async function searchExplore({ nextId }) {
  const { data } = await exploreRes({ next_id: nextId });
  return {
    list: data.products,
    nextId: data.next_id,
  };
}

/**
 * 获取当前坐标点
 * @returns {Promise<any>}
 */
export function getPosition() {
  return new Promise((resolve, reject) => {
    let lng;
    let lat;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          lng = position.coords.longitude;
          lat = position.coords.latitude;
          resolve({ lng, lat });
        },
        (e) => {
          resolve({ lng: 0, lat: 0 });
        }
      );
    } else {
      reject(initValidate({ msg: "geolocation not support" }));
    }
  });
}

/**
 * 获取Ins发送的图片以及待发送图片
 */
export async function getInsMedias({ uid }) {
  const currentPublisher = store.getters[CURRENT_PUBLISHER_SIMPLE];
  // 先获取最近待生成的Ins
  const { data } = await mediaList({
    uid: uid || currentPublisher.socialUid,
    accessToken: currentPublisher.userToken,
  });
  let postMediaList = [];
  data.data
    // .filter(detail => {
    //   return detail.media_type === 'IMAGE'
    // })
    .forEach((detail) => {
      let media_type = 1;
      let images = [""];
      let coverUrl = detail.media_url;
      if (detail.media_type === "VIDEO") {
        media_type = 2;
        coverUrl = detail.thumbnail_url;
      } else if (detail.media_type === "CAROUSEL_ALBUM") {
        images = ["", ""];
      }
      postMediaList.push({
        from: "instagram",
        coverUrl,
        id: detail.id,
        media_type,
        images,
      });
    });
  return {
    medias: postMediaList,
  };
}

/**
 * 获取top信息
 * @param q 查询条件
 * @returns {Promise<void>}
 */
export async function searchTop({ q, cancelToken }) {
  let { lat, lng } = await getPosition();
  const { data } = await searchTopRes({ q, lat, lng, cancelToken });
  return data.map((d) => formatSearch({ data: d.model_data, type: d.model }));
}

/**
 * 获取tag信息
 * @param q 查询条件
 * @returns {Promise<void>}
 */
export async function searchTag({ q, cancelToken }) {
  const { data } = await searchTagRes({ q, cancelToken });
  return data.map((d) => formatSearch({ data: d, type: "InstagramTag" }));
}

/**
 * 获取people信息
 * @param q 查询条件
 * @returns {Promise<void>}
 */
export async function searchPeople({ q, cancelToken }) {
  const { data } = await searchInsUsersRes({ q, cancelToken });
  return data.map((d) => formatSearch({ data: d, type: "InstagramUser" }));
}

/**
 * 获取location信息
 * @param q 查询条件
 * @returns {Promise<void>}
 */
export async function searchLocation({ q, cancelToken }) {
  const currentPublisher = store.getters[CURRENT_PUBLISHER_SIMPLE];
  // let { lat, lng } = await getPosition()
  const { data } = await locationRes({
    accessToken: currentPublisher,
    q,
    cancelToken,
  });
  return data.map((d) => formatSearch({ data: d, type: "InstagramLocation" }));
}

/**
 * 查询user对应post信息
 * @param uid
 * @param nextId
 * @returns {Promise<{list: *, nextId: (*|number)}>}
 */
export async function searchUserPost({ uid, nextId }) {
  const { data: post } = await mediaList({ uid, next_id: nextId });
  return {
    list: post.medias.map((m) => new Post(m)),
    nextId: post.next_id,
  };
}

/**
 * 获取查询的详情
 * @returns {Promise<void>}
 */
export async function searchDetail({ item, nextId }) {
  let result = {};
  if (item.type === "InstagramUser") {
    const { data: user } = await userDetailRes({ vr: `id${item.id}` });
    const { data: story } = await userStoriesRes({ uid: item.id });
    const { data: post } = await mediaList({ uid: item.id });
    user.story = {
      list: story.medias.map((m) => new Post(m)),
      nextId: null,
    };
    user.post = {
      list: post.medias.map((m) => new Post(m)),
      nextId: post.next_id,
    };
    return user;
  } else if (item.type === "InstagramTag") {
    const { data } = await tagMediasRes({ id: item.id, next_id: nextId });
    result = {
      list: data.medias.map((m) => new Post(m)),
      nextId: data.next_id,
    };
  } else if (item.type === "InstagramLocation") {
    const { data } = await locationMedias({ id: item.id, next_id: nextId });
    result = {
      list: data.medias.map((m) => new Post(m)),
      nextId: data.next_id,
    };
  } else if (item.type === "InstagramExplore") {
    const { data } = await exploreRes({ next_id: nextId });
    result = {
      list: data.medias.map((m) => new Post(m)),
      nextId: data.next_id,
    };
  }
  return result;
}

/**
 * 格式化search repost的返回结果
 * @param data 接口返回数据
 * @param type 类型
 */
export function formatSearch({ data, type }) {
  // ins用户查询
  if (type === "InstagramUser") {
    return {
      id: data.id,
      verify: data.is_verified,
      story: data.latest_story,
      title: data.username,
      des: data.full_name,
      image: data.profile_pic_url,
      type,
    };
  } else if (type === "InstagramTag") {
    const re = /(?=(?!(\b))(\d{3})+$)/g;
    const des = `${data.medias.toString().replace(re, ",")} public posts`;
    return {
      id: data.name,
      title: data.name,
      des,
      image: "xxx",
      type,
    };
  } else if (type === "InstagramLocation") {
    return {
      id: data.external_id,
      title: data.name,
      des: data.address,
      image: "xxx",
      type,
    };
  }
}
